<template>
  <div>
    <h1 class="common__main-title">Clock In</h1>
    <div v-if="clockIns">
      <Search class="search" ref="searchCondition" @changedConditions="changeConditions" />
      <div class="d-flex justify-content-between aligin-center mb-4">
        <div @click="beforeDay" class="before-button">
          &lt;&lt; previous
        </div>
        <div class="datepickerContent">
          <Datepicker
            :input-class="'datepickerInput'"
            :wrapper-class="'lesson-date'"
            :value="date.toDate()"
            @input="changeDateOnCalendar"
            :format="'yyyy-MM-dd'"
            name="datepicker"
          />
          <font-awesome-icon :icon="'calendar'" class="calendar-icon"/>
        </div>
        <div @click="nextDay" class="next-button">
          next &gt;&gt;
        </div>
      </div>
      <ClockInList :date="date" :clockIns="clockIns" />
    </div>
    <Loading :isLoading="isLoading"/>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import moment, { Moment } from 'moment'
import _ from 'lodash'
import Datepicker from 'vuejs-datepicker'
import ClockInList from '@/components/parts/clockIn/ClockInList.vue'
import Search from '@/components/parts/clockIn/ClockInSearch.vue'
import Loading from '@/components/parts/modal/Loading.vue'
import { ClockIn, ClockInSearchConditions } from '@/store/clockIn/types'

export default Vue.extend({
  components: {
    Search,
    ClockInList,
    Datepicker,
    Loading,
  },

  data(): {
    date: Moment,
    isLoading: boolean,
    conditions: ClockInSearchConditions | undefined,
    } {
    return {
      date: moment(),
      isLoading: false,
      conditions: undefined,
    }
  },

  created(): void {
    if (this.$route.params.date) {
      this.date = moment(this.$route.params.date, 'YYYYMMDD')
    }
    this.search()
  },

  computed: {
    clockIns(): ClockIn[] {
      return this.$store.state.clockIn.clockIns
    },
  },

  watch: {
    // ルートが変更されたらこのメソッドを再び呼び出します
    $route: 'search',
  },

  methods: {
    // 日付変更
    changeDate(date: Moment) {
      this.date = date
      this.$router.push({
        name: 'ClockIns',
        params: { date: date.format('YYYYMMDD') },
      })
    },

    changeDateOnCalendar(date: Date) {
      this.changeDate(moment(date))
    },
    // 前の日に遷移
    beforeDay() {
      this.changeDate(this.date.add(-1, 'days'))
    },

    // 次の日に遷移
    nextDay() {
      this.changeDate(this.date.add(+1, 'days'))
    },

    changeConditions(conditions: ClockInSearchConditions) {
      this.conditions = conditions
      this.search()
    },

    // 検索
    search() {
      this.isLoading = true
      this.$store.dispatch('fetchClockIns', {
        date: this.date,
        conditions: this.conditions,
      })
        .finally(() => {
          this.isLoading = false
        })
    },
  },
})
</script>

<style scoped>

.lesson-date {
  background: #BBD6EE;
  border-radius:30px;
}

.lesson-date-text {
  margin-right:20px;
  font-size: 16px;
  line-height: 16px;
}

.lesson-date .container__title {
  margin-right:20px;
}

.calendar {
  position:relative;
}

.calendar-icon {
  position:absolute;
  right:20px;
  bottom:0;
  top:0;
  margin:auto 0;
  cursor:pointer;
  pointer-events: none;
}

.datepickerContent {
  display:flex;
  position:relative;
}

.before-button, .next-button {
  border: 2px solid #AAAFB6;
  border-radius: 30px;
  color: #000;
  padding:5px 10px;
  -webkit-transition: .2s;
  transition: .2s;
  user-select:none;
}

.before-button:hover, .next-button:hover {
  cursor: pointer;
  background: #AAAFB6;
}

</style>

<style>
  .datepickerInput {
    border:none;
    font-size:15px;
    display:block;
    padding:5px 20px;
    background:none;
    cursor:pointer;
  }
</style>
